export default __webpack_public_path__ + "static/media/6.b352af99.webp";